import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    error: 'An error occurred. Please try again.',
    no: 'No',
    sidebar: {
      answers: {
        1: `Acre ("Aide à la création ou à la reprise d'une entreprise") or Aid for Creation or Takeover of a Business) allows you to be exempt from a portion of your social security contributions (approximately half) during the first 4 quarters of your activity. In a microenterprise, this assistance is granted if you meet at least one of the following criteria:`,
        2: 'The complete and official list of criteria ',
        3: 'You can only benefit from this assistance when creating or taking over a business. If you have already benefited from it in the past (for another project), you will need to wait at least 3 years to benefit from it again, even if your situation makes you eligible by default.',
        link: 'can be consulted here.',
      },
      bullets: {
        1: 'Being unemployed (subject to conditions)',
        2: 'Receiving social benefits such as RSA, ASS, or ATA',
        3: 'Being aged between 18 and 25 (up to 29 if you are recognized as disabled)',
        4: 'Your microenterprise is located in a priority neighborhood (QPPV)',
      },
      question: 'What is Acre?',
      title: 'Learn more…',
    },
    title: 'You benefit from Acre',
    yes: 'Yes',
  },
  fr: {
    error: 'Une erreur est survenue. Veuillez réessayer.',
    no: 'Non',
    sidebar: {
      answers: {
        1: 'L’Acre désigne l’Aide à la Création ou à la Reprise d’une Entreprise. Elle vous permet d’être exonéré·e d’une partie de vos cotisations sociales (environ la moitié), pendant les 4 premiers trimestres de votre activité. En micro-entreprise, cette aide est accordée si vous répondez à au moins un des critères suivants :',
        2: 'La liste complète et officielle des critères ',
        3: 'Vous pouvez bénéficier de cette aide uniquement lors de la création ou de la reprise d’une entreprise. Si vous en avez déjà bénéficié dans le passé (pour un autre projet), il vous faudra attendre au moins 3 ans pour en bénéficier de nouveau, même si votre situation vous rend éligible de base.',
        link: 'est consultable ici.',
      },
      bullets: {
        1: 'Être demandeur ou demandeuse d’emploi (sous-condition)',
        2: 'Être bénéficiaire d’aides sociales comme le RSA, l’ASS ou l’ATA',
        3: 'Avoir entre 18 et 25 ans (jusque 29 ans si vous êtes reconnu·e en situation de handicap)',
        4: 'Votre micro-entreprise se trouve dans un quartier prioritaire de la ville (QPPV)',
      },
      question: 'Qu’est-ce que l’Acre ?',
      title: 'En savoir plus…',
    },
    title: 'Vous bénéficiez de l’Acre',
    yes: 'Oui',
  },
} as const);
